// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ButtonsSelected__text-bb7364 {
  font-style: normal;
  font-weight: normal;
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-110);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/bots/ButtonsSelected/styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF","sourcesContent":[".text {\n  font-style: normal;\n  font-weight: normal;\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-110);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `ButtonsSelected__text-bb7364`
};
module.exports = ___CSS_LOADER_EXPORT___;
